import React, { useState, useEffect } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";
import { toast, Bounce } from "react-toastify";

const CancelAccount = ({ data, setApiRun }) => {
	const [reason, setReason] = useState("");
	const [isCharged, setIsCharged] = useState("");
	const [error, setError] = useState("");
	const { fetchPostData } = useFetchPost();

	const handleClose = () => {
		const cancelAccountModal = document.getElementById("cancelAccount");
		cancelAccountModal.classList.remove("show");
		cancelAccountModal.style.display = "none";
	};

	const handleReason = (event) => {
		setReason(event.target.value);
	};
	const handleIsCharged = (event) => {
		setIsCharged(event.target.value);
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		// if (!password.trim()) {
		// 	setError("Please enter new password");
		// 	return;
		// }
		// Process the data or perform any actions
		const postData = {
			product_key: data && data.product,
			app_token: data && data.customer_id,
			studio_id: data && data.customer_id,
			user_id: data && data.customer_user_uuid,
			is_live: data && data.isLive,
			inputs: {
				custom_notes: reason,
				is_charged: isCharged,
			},
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/cancel-account";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}

		if (responseData && responseData.status == "OK") {
			setApiRun(true); // customer list api run
			setReason("");
			setIsCharged("");
			setError("");
			toast.success("Account cancelled successfully", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			toast.error("Error Occured ! try again.", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			console.warn("Something went wrong in cancel account");
		}

		// Close the modal
		const changePasswordModal = document.getElementById("cancelAccount");
		changePasswordModal.classList.remove("show");
		changePasswordModal.style.display = "none";
		// const backdrop = document.querySelector(".modal-backdrop");
		// backdrop.style.display = "none";
	};

	return (
		<div className="modal fade" id="cancelAccount" tabindex="-1" role="dialog" aria-labelledby="cancelAccountLabel">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="cancelAccountLabel">
							Cancel Account
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Company
								</label>
								<input
									type="text"
									className="form-control"
									disabled
									value={data && data.company_name}
								/>
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Reason
								</label>
								<input type="text" className="form-control" value={reason} onChange={handleReason} />
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Do you want to charge this customer?
								</label>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="3"
										type="radio"
										name="is_charged"
										value="1"
										onChange={handleIsCharged}
									/>
									<label for="3">
										<span></span>Yes
									</label>
								</div>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="4"
										type="radio"
										name="is_charged"
										value="0"
										onChange={handleIsCharged}
									/>
									<label for="4">
										<span></span>No
									</label>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CancelAccount;



// WEBPACK FOOTER //
// ./src/components/crm/modals/CancelAccount.jsx